import React from 'react';
import { isMastheadCategoryMenu } from '../../../../../../utils/contentful';
import { TextLink } from '../../../../../LinkV2';
import { ContentfulCategoryMenu, } from '../../../../FlyoutMenu/MenuLayouts/CategoryMenu/ContentfulCategoryMenu';
import { trackCat } from '../../../constants';
import { ContentfulGalleryMenu, } from '../../../../FlyoutMenu/MenuLayouts/GalleryMenu/ContentfulGalleryMenu';
import { useActiveSubmenu } from '../../../../../ActiveSubmenu/ActiveSubmenuProvider';
export const SubmenuTrigger = ({ id, label, }) => {
    const { claimActiveSubmenu } = useActiveSubmenu(id);
    return (React.createElement(TextLink, { id: id, trackingLabel: label, trackingCategory: trackCat, label: label, size: "xlarge", onClick: claimActiveSubmenu, svgIcon: "IconChevronRight", fullWidth: true }));
};
export const SubMenu = ({ activeItem, onNavigate = () => { }, }) => {
    return (React.createElement(React.Fragment, null, isMastheadCategoryMenu(activeItem) ? (React.createElement(ContentfulCategoryMenu, { activeItem: activeItem, onNavigate: onNavigate })) : (React.createElement(ContentfulGalleryMenu, { activeItem: activeItem, onNavigate: onNavigate }))));
};
//# sourceMappingURL=SubMenu.js.map